var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88861 12L4.65969 17.5301C4.321 19.0542 5.48076 20.5 7.04204 20.5C8.18589 20.5 9.17626 19.7056 9.4244 18.5889L9.7775 17H8.24091L7.96012 18.2635C7.86449 18.6938 7.48284 19 7.04204 19C6.44038 19 5.99345 18.4429 6.12397 17.8555L7.20298 13H9.12979L8.57424 15.5H10.1108L10.6664 13L10.8886 12H5.88861ZM13.1108 12L13.3331 13L13.8886 15.5H15.4252L14.8696 13H16.7965L17.8755 17.8555C18.006 18.4429 17.5591 19 16.9574 19C16.5166 19 16.1349 18.6938 16.0393 18.2635L15.7585 17H14.2219L14.575 18.5889C14.8232 19.7056 15.8135 20.5 16.9574 20.5C18.5187 20.5 19.6784 19.0542 19.3397 17.5301L18.1108 12H13.1108Z",
    fill: "#2B323B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18.5H9V17H15V18.5Z",
    fill: "#2B323B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 15.5H9.5V14H14.5V15.5Z",
    fill: "#2B323B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12L9 5H10.5L3.5 12H2Z",
    fill: "#2B323B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12L14.5 5H16L9 12H7.5Z",
    fill: "#2B323B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12L20 5H21.5L14.5 12H13Z",
    fill: "#2B323B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65 5C2.65 4.8067 2.8067 4.65 3 4.65H21C21.1933 4.65 21.35 4.8067 21.35 5V12C21.35 12.1933 21.1933 12.35 21 12.35H3C2.8067 12.35 2.65 12.1933 2.65 12V5Z",
    stroke: "#2B323B",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruction);
export default __webpack_public_path__ + "static/media/construction.64b695fe75d53a4ce8f2f4f9030e93ea.svg";
export { ForwardRef as ReactComponent };